// extracted by mini-css-extract-plugin
export default {"list":"dgUT8pvO_6"};